import localStorage from 'platform/utilities/storage/localStorage';

// `sessionExpiration` is the same value SessionTimeoutModal counts down
// against, and `teardownProfileSession` removes it on sign-out.

export const VA_SESSION_EXPIRATION_KEY = 'sessionExpiration';

/**
 * @returns {number|null} epoch ms the VA.gov session ends, or null when there
 * is no usable expiration stored.
 */
export function getVaSessionExpiration() {
  const raw = localStorage.getItem(VA_SESSION_EXPIRATION_KEY);
  if (!raw) return null;

  const ts = new Date(raw).getTime();
  return Number.isFinite(ts) ? ts : null;
}

/**
 * @param {number} [now] epoch ms, injectable for tests
 * @returns {boolean} true only when a VA.gov session exists and has lapsed
 */
export function hasVaSessionExpired(now = Date.now()) {
  const expiresAt = getVaSessionExpiration();
  if (expiresAt === null) return false;
  return now >= expiresAt;
}
